module.exports = __webpack_public_path__ + "img/pgd_a_00010.420110eb.png";